import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import image from '../../images/nasirul01.png';
import './Banner.css';

const Banner = () => {
    return (
        <div className="banner">
            <Container className="">
                <Row className="">
                    <Col sm={12} md={6} lg={6}
                        className="d-flex justify-content-start align-items-center">
                        <div className="text-start text-white">
                            <p className="">WELCOME TO MY WORLD</p>
                            <h1 className="">Hi, I’m Nasirul Islam <br />
                                Web Developer.
                            </h1>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={6}>
                        <img width="100%" src={image} alt="my_photo" />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Banner;